import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import {
  OrderConversionChartStatuses,
  OrderConversionProviderChart,
} from 'types/embedded/orderConversion';

import {
  OrderConversionChartProvidersRatioHintBox,
  OrderConversionChartProvidersRatioScrollBox,
  StyledBox,
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
} from './OrderConversionChartProvidersRatio.styled';
import { OrderConversionChartProvidersRatioBar } from './OrderConversionChartProvidersRatioBar';
import { OrderConversionChartProvidersRatioHint } from './OrderConversionChartProvidersRatioHint';

type Props = { data: OrderConversionProviderChart };

export const OrderConversionChartProvidersRatio: React.FC<Props> = ({ data }) => {
  const translate = useTypedTranslate();

  return (
    <StyledCard>
      <StyledCardHeader
        description={translate('app.orderConversionCharts.byProvidersForPeriod')}
        descriptionProps={{ fontSize: '12px' }}
        title={translate('app.orderConversionCharts.orderRatio')}
        titleSize="small"
      />
      <StyledCardContent>
        <StyledBox>
          <OrderConversionChartProvidersRatioBar
            title={translate('app.orderConversionCharts.totalOrders')}
            {...data.total}
          />
        </StyledBox>
        <OrderConversionChartProvidersRatioScrollBox>
          {data?.providers?.map((providerRatio, index) => (
            <OrderConversionChartProvidersRatioBar key={index} {...providerRatio} />
          ))}
        </OrderConversionChartProvidersRatioScrollBox>
        <OrderConversionChartProvidersRatioHintBox>
          <OrderConversionChartProvidersRatioHint
            status={OrderConversionChartStatuses.Success}
            title={translate('app.orderConversionCharts.status.successful')}
          />
          <OrderConversionChartProvidersRatioHint
            status={OrderConversionChartStatuses.Pending}
            title={translate('app.orderConversionCharts.status.pending')}
          />
          <OrderConversionChartProvidersRatioHint
            status={OrderConversionChartStatuses.Failure}
            title={translate('app.orderConversionCharts.status.failed')}
          />
        </OrderConversionChartProvidersRatioHintBox>
      </StyledCardContent>
    </StyledCard>
  );
};
